module.exports = __webpack_public_path__ + "img/lb_yqkc.b2a51785.svg";